import { Component } from '@angular/core';
import { IllustratedModal } from '../../../shared/components/illustrated-modal/illustrated-modal';
import { CrossComponentService } from '../../../core/services/cross-component.service';
import { RouterLink } from '@angular/router';
import { IntersectionObserverDirective } from '../../../core/directives/animate-on-visible.directive';


@Component({
  selector: 'app-search',
  imports: [IllustratedModal, RouterLink, IntersectionObserverDirective],
  templateUrl: './search.html',
  styleUrl: './search.scss',
})
export class Search {
  constructor(public crossComponentService: CrossComponentService) { }
}
